<template>
  <fragment>
    <div class="columns">
      <div class="column is-10">
        <h3 class="is-size-4 mb-4">Reporte en tiempo real estado de camas</h3>
      </div>
      <div class="column is-12">
        <!-- <b-button class="is-primary" icon-left="download" :disabled="isLoading" @click="generatePdf" :loading="loadingButtonReportPdf">Descargar</b-button> -->
        <b-button class="is-primary" icon-left="download" :disabled="isLoading" @click="openDownloadReportModal" :loading="loadingButtonReportPdf">Descargar</b-button>
      </div>
    </div>
    <hr>
    <!-- <transition name="fade" mode="out-in"> -->
      <loader v-if="isLoading"></loader>
      <!-- <span v-if="isLoading">Cargando...</span> -->
      <div v-else class="table-container" style="max-height: 550px; overflow-y: scroll">
        <table class="table is-striped is-bordered is-narrow is-fullwidth is-hoverable">
          <thead>
            <tr class="header">
              <th width="450" style="border: 0px solid;"></th>
              <th class="col-header" colspan="8" v-for="stablishment in stablishments" :key="stablishment.id">{{ stablishment.name }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 0px solid"></td>
              <fragment v-for="(stablishment, index) in stablishmentDataCritical" :key="index">
                <td><b>HABILITADAS</b></td>
                <td><b>DISPONIBLE</b></td>
                <td><b>OCUPADAS</b></td>
                <td><b>BLOQUEADAS</b></td>
                <td><b>VENT. DISPONIBLE</b></td>
                <td><b>VENT. OCUPADO</b></td>
                <td><b>COVID19</b></td>
                <td><b>%OCUP.</b></td>
              </fragment>
            </tr>
            <tr v-for="dataCriticalBed in dataCriticalBeds" :key="dataCriticalBed.subcategorization.id">
              <td >{{dataCriticalBed.subcategorization.name}}</td>
              <fragment v-for="(stablishment, index) in dataCriticalBed.stablishments" :key="index">
                <td>{{stablishment.total == 0 ? '-' : stablishment.enabled}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.enabled - stablishment.occupied}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.occupied}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.blocked}}</td>
                <td>{{stablishment.hasVentilator == 0 ? '-' : stablishment.hasVentilator - stablishment.ventilator}}</td>
                <td>{{stablishment.hasVentilator == 0 ? '-' : stablishment.ventilator}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.covid19}}</td>
                <td>{{stablishment.total == 0 ? '-' : `${stablishment.occupation} %`}}</td>
              </fragment>
            </tr>
            <tr class="col-subheader">
              <td ><b>% Camas Críticas</b></td>
              <fragment v-for="(stablishment, index) in stablishmentDataCritical" :key="index">
                <td>{{stablishment.total == 0 ? '-' : stablishment.enabled}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.enabled - stablishment.occupied}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.occupied}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.blocked}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.hasVentilator - stablishment.ventilator}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.ventilator}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.covid19}}</td>
                <td :class="stablishment.total == 0 ? '' : 'col-percentage'">{{ stablishment.total == 0 ? '-' : `${stablishment.occupation} %` }}</td>
              </fragment>
            </tr>
            <tr>
              <td style="border: 0px solid"></td>
              <fragment v-for="(stablishment, index) in stablishmentDataCritical" :key="index">
                <td><b>HABILITADAS</b></td>
                <td><b>DISPONIBLE</b></td>
                <td><b>OCUPADAS</b></td>
                <td><b>BLOQUEADAS</b></td>
                <td><b>VENT. DISPONIBLE</b></td>
                <td><b>VENT. OCUPADO</b></td>
                <td><b>COVID19</b></td>
                <td><b>%OCUP.</b></td>
              </fragment>
            </tr>
            <tr v-for="dataMediumBed in dataMediumBeds" :key="dataMediumBed.subcategorization.id">
              <td >{{dataMediumBed.subcategorization.name}}</td>
              <fragment v-for="(stablishment, index) in dataMediumBed.stablishments" :key="index">
                <td>{{stablishment.total == 0 ? '-' : stablishment.enabled}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.enabled - stablishment.occupied}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.occupied}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.blocked}}</td>
                <td>{{stablishment.hasVentilator == 0 ? '-' : stablishment.hasVentilator - stablishment.ventilator}}</td>
                <td>{{stablishment.hasVentilator == 0 ? '-' : stablishment.ventilator}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.covid19}}</td>
                <td>{{stablishment.total == 0 ? '-' : `${stablishment.occupation} %`}}</td>
              </fragment>
            </tr>
            <tr class="col-subheader">
              <td><b>% Camas Medias</b></td>
              <fragment v-for="(stablishment, index) in stablishmentDataMedium" :key="index">
                <td>{{stablishment.total == 0 ? '-' : stablishment.enabled}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.enabled - stablishment.occupied}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.occupied}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.blocked}}</td>
                <td>{{stablishment.hasVentilator == 0 ? '-' : stablishment.hasVentilator - stablishment.ventilator}}</td>
                <td>{{stablishment.hasVentilator == 0 ? '-' : stablishment.ventilator}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.covid19}}</td>
                <td :class="stablishment.total == 0 ? '' : 'col-percentage'">{{ stablishment.total == 0 ? '-' : `${stablishment.occupation} %` }}</td>
              </fragment>
            </tr>
            <tr>
              <td style="border: 0px solid"></td>
              <fragment v-for="(stablishment, index) in stablishmentDataCritical" :key="index">
                <td><b>HABILITADAS</b></td>
                <td><b>DISPONIBLE</b></td>
                <td><b>OCUPADAS</b></td>
                <td><b>BLOQUEADAS</b></td>
                <td><b>VENT. DISPONIBLE</b></td>
                <td><b>VENT. OCUPADO</b></td>
                <td><b>COVID19</b></td>
                <td><b>%OCUP.</b></td>
              </fragment>
            </tr>
            <tr v-for="dataBasicBed in dataBasicBeds" :key="dataBasicBed.subcategorization.id">
              <td>{{dataBasicBed.subcategorization.name}}</td>
              <fragment v-for="(stablishment, index) in dataBasicBed.stablishments" :key="index">
                <td>{{stablishment.total == 0 ? '-' : stablishment.enabled}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.enabled - stablishment.occupied}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.occupied}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.blocked}}</td>
                <td>{{stablishment.hasVentilator == 0 ? '-' : stablishment.hasVentilator - stablishment.ventilator}}</td>
                <td>{{stablishment.hasVentilator == 0 ? '-' : stablishment.ventilator}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.covid19}}</td>
                <td>{{stablishment.total == 0 ? '-' : `${stablishment.occupation} %`}}</td>
              </fragment>
            </tr>
            <tr class="col-subheader">
              <td><b>% Camas Básicas</b></td>
              <fragment v-for="(stablishment, index) in stablishmentDataBasic" :key="index">
                <td>{{stablishment.total == 0 ? '-' : stablishment.enabled}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.enabled - stablishment.occupied}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.occupied}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.blocked}}</td>
                <td>{{stablishment.hasVentilator == 0 ? '-' : stablishment.hasVentilator - stablishment.ventilator}}</td>
                <td>{{stablishment.hasVentilator == 0 ? '-' : stablishment.ventilator}}</td>
                <td>{{stablishment.total == 0 ? '-' : stablishment.covid19}}</td>
                <td :class="stablishment.total == 0 ? '' : 'col-percentage'">{{ stablishment.total == 0 ? '-' : `${stablishment.occupation} %` }}</td>
              </fragment>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="!isLoading && !stablishmentId" class="table-container">
        <table class="table is-striped is-bordered is-narrow is-fullwidth is-hoverable">
          <thead>
            <tr class="header has-text-centered">
              <th style="border: 0px solid;"></th>
              <th class="col-header" colspan="6">CRÍTICAS</th>
              <th class="col-header" colspan="2" rowspan="2">% OCUPACIÓN UCI/UTI</th>
              <th class="col-header" colspan="2">VENTILADORES</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="2">HOSPITAL</td>
              <td colspan="2">Habilitadas</td>
              <td colspan="2">Ocupadas</td>
              <td colspan="2">Disponibles</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>UCI</td>
              <td>UTI</td>
              <td>UCI</td>
              <td>UTI</td>
              <td>UCI</td>
              <td>UTI</td>
              <td>UCI</td>
              <td>UTI</td>
              <td>OCUPADOS</td>
              <td>DISPONIBLES</td>
            </tr>
            <tr v-for="(row, index) in summaryTable.slice(0, summaryTable.length-1)" :key="index">
              <td>{{row.name}}</td>
              <td>{{row.uciEnabled}}</td>
              <td>{{row.utiEnabled}}</td>
              <td>{{row.uciOccupied}}</td>
              <td>{{row.utiOccupied}}</td>
              <td>{{row.uciAvailable}}</td>
              <td>{{row.utiAvailable}}</td>
              <td>{{ row.uciEnabled == 0 ? 0 : (row.uciOccupied*100/row.uciEnabled).toFixed(2)  }}%</td>
              <td>{{ row.utiEnabled == 0 ? 0 : (row.utiOccupied*100/row.utiEnabled).toFixed(2)  }}%</td>
              <td>{{row.occupiedVentilators}}</td>
              <td>{{row.availableVentilators}}</td>
            </tr>
            <tr>
              <td><b>{{summaryTable[summaryTable.length-1].name}}</b></td>
              <td colspan="2" class="has-text-centered"><b>{{summaryTable[summaryTable.length-1].uciEnabled + summaryTable[summaryTable.length-1].utiEnabled}}</b></td>
              <td colspan="2" class="has-text-centered"><b>{{summaryTable[summaryTable.length-1].uciOccupied + summaryTable[summaryTable.length-1].utiOccupied}}</b></td>
              <td colspan="2" class="has-text-centered"><b>{{summaryTable[summaryTable.length-1].uciAvailable + summaryTable[summaryTable.length-1].utiAvailable}}</b></td>
              <td colspan="2"></td>
              <td class="has-text-centered"><b>{{summaryTable[summaryTable.length-1].occupiedVentilators}}</b></td>
              <td class="has-text-centered"><b>{{summaryTable[summaryTable.length-1].availableVentilators}}</b></td>
            </tr>
            <tr class="has-text-centered">
              <td colspan="3">Ocupación</td>
              <td colspan="4" class="has-text-centered"><b>{{calculateCriticOcupation()}}%</b></td>
              <td colspan="2"></td>
              <td colspan="2" class="has-text-centered"><b>{{calculateVentilatorOcupation()}}%</b></td>
            </tr>
          </tbody>
        </table>
      </div>
    <!-- </transition> -->
  </fragment>
</template>
<script>
import { GetSubcategorizationByClassification } from "../../services/subCategorization";
import { GetAllStablishment } from "../../services/stablishment";
import { Fragment } from "vue-fragment";
import { BedFindByStablishmentSubCatId } from "../../services/beds";

import Loader from "./../../components/general/Loader"
import ModalStateBedReport from "./../../components/reports/ModalStateBedReport";
import { eventBus } from '../../main';
// import html2canvas from 'html2canvas';
// import moment from "moment";
export default {
  props: ["stablishmentId"],
  components: {
    Fragment,
    Loader
  },
  data() {
    return {
      dataCriticalBeds: [],
      dataMediumBeds: [],
      dataBasicBeds: [],
      classifications: ["critica", "media", "basica"],
      stablishments: [],
      stablishmentDataCritical: [],
      stablishmentDataMedium: [],
      stablishmentDataBasic: [],
      isLoading: true,
      loadingButtonReportPdf: false,
      summaryTable: [
        {
          id: "puq",
          name: "Punta Arenas",
          ids: [2],
          uciEnabled: 0,
          utiEnabled: 0,
          uciOccupied: 0,
          utiOccupied: 0,
          uciAvailable: 0,
          utiAvailable: 0,
          uciOcupation: 0,
          utiOcupation: 0,
          occupiedVentilators: 0,
          availableVentilators: 0
        },
        {
          id: "natales",
          name: "Puerto Natales",
          ids: [1],
          uciEnabled: 0,
          utiEnabled: 0,
          uciOccupied: 0,
          utiOccupied: 0,
          uciAvailable: 0,
          utiAvailable: 0,
          uciOcupation: 0,
          utiOcupation: 0,
          occupiedVentilators: 0,
          availableVentilators: 0
        },
        {
          id: "ffaa",
          name: "F.F.A.A.",
          ids: [5],
          uciEnabled: 0,
          utiEnabled: 0,
          uciOccupied: 0,
          utiOccupied: 0,
          uciAvailable: 0,
          utiAvailable: 0,
          uciOcupation: 0,
          utiOcupation: 0,
          occupiedVentilators: 0,
          availableVentilators: 0
        },
        {
          id: "clinica",
          name: "Clínica",
          ids: [6],
          uciEnabled: 0,
          utiEnabled: 0,
          uciOccupied: 0,
          utiOccupied: 0,
          uciAvailable: 0,
          utiAvailable: 0,
          uciOcupation: 0,
          utiOcupation: 0,
          occupiedVentilators: 0,
          availableVentilators: 0
        },
        {
          id: "total",
          name: "Total",
          ids: ["total"],
          uciEnabled: 0,
          utiEnabled: 0,
          uciOccupied: 0,
          utiOccupied: 0,
          uciAvailable: 0,
          utiAvailable: 0,
          occupiedVentilators: 0,
          availableVentilators: 0
        },
      ],
    };
  },
  async mounted() {
    this.isLoading = true;
    let promises = [];
    promises.push(
      new Promise((resolve) => {
        this.getCriticalData()
          .then(() => {
            resolve();
          })
          .catch((err) => {
            console.log(err);
          })
      }) 
    )
    promises.push(
      new Promise((resolve) => {
        this.getMediumData()
          .then(() => {
            resolve();
          })
          .catch((err) => {
            console.log(err);
          })
      }) 
    )
    promises.push(
      new Promise((resolve) => {
        this.getBasicData()
          .then(() => {
            resolve();
          })
          .catch((err) => {
            console.log(err);
          })
      }) 
    )
    Promise.all(promises)
      .then(() => {
        this.isLoading = false;
        eventBus.$emit("emitJsonBedStateReport", {
          dataCriticalBeds: this.dataCriticalBeds,
          dataMediumBeds: this.dataMediumBeds,
          dataBasicBeds: this.dataBasicBeds,
          classifications: this.classifications,
          stablishments: this.stablishments,
          stablishmentDataCritical: this.stablishmentDataCritical,
          stablishmentDataMedium: this.stablishmentDataMedium,
          stablishmentDataBasic: this.stablishmentDataBasic,
          summaryTable: this.summaryTable
        })
      })
      .catch((err) => {
        console.log(err);
      })
  },
  methods: {
    calculateVentilatorOcupation() {
      let totalOccupied = this.summaryTable[this.summaryTable.length-1].occupiedVentilators;
      let totalAvailable = this.summaryTable[this.summaryTable.length-1].availableVentilators;
      let total = totalOccupied + totalAvailable;
      let occupation = total == 0 ? 0 : ((totalOccupied*100)/total).toFixed(2);
      return occupation;
    },
    calculateCriticOcupation() {
      let totalOccupied = this.summaryTable[this.summaryTable.length-1].uciOccupied + this.summaryTable[this.summaryTable.length-1].utiOccupied;
      let totalAvailable = this.summaryTable[this.summaryTable.length-1].uciAvailable + this.summaryTable[this.summaryTable.length-1].utiAvailable;
      let total = totalOccupied + totalAvailable;
      let occupation = total == 0 ? 0 : ((totalOccupied*100)/total).toFixed(2);
      return occupation;
    },
    openDownloadReportModal() {
      window.scrollTo(0,0);
      this.$buefy.modal.open({
        parent: this,
        component: ModalStateBedReport,
        width: 1100,
        // fullScreen: true,
        props: {
          tableData: {
            stablishments: this.stablishments,
            dataCriticalBeds: this.dataCriticalBeds,
            dataMediumBeds: this.dataMediumBeds,
            dataBasicBeds: this.dataBasicBeds,
            stablishmentDataCritical: this.stablishmentDataCritical,
            stablishmentDataMedium: this.stablishmentDataMedium,
            stablishmentDataBasic: this.stablishmentDataBasic,
            summaryTable: this.summaryTable
          },
          stablishmentId: this.stablishmentId
        },
        hasModalCard: true,
      });
    },
    async getBasicData() {
      let stablishments = await GetAllStablishment(this.$http);
      if (this.stablishmentId) {
        stablishments = stablishments.filter(stablishment => stablishment.id == this.stablishmentId);
      }
      this.stablishments = stablishments.map((stablishment, index) => {
        return {
          ...stablishment,
          index
        }
      });
      this.stablishmentDataBasic = this.stablishments.map(stablishment => {
        return {
          ...stablishment,
          total: 0,
          enabled: 0,
          occupied: 0,
          blocked: 0,
          occupation: 0,
          ventilator: 0,
          hasVentilator: 0,
          covid19: 0
        }
      });
      const subcategorizations = await GetSubcategorizationByClassification(
        this.$http,
        "basica"
      );
      let subcategorizationPromises = [];
      subcategorizations.forEach(subcategorization => {
        subcategorizationPromises.push(
          new Promise((resolveSub) => {
            let subcategorizationData = {
              subcategorization,
              stablishments: [],
            };
            let stablishmentPromises = [];
            this.stablishments.forEach(stablishment => {
              stablishmentPromises.push(
                new Promise((resolveStablishment) => {
                  BedFindByStablishmentSubCatId(this.$http, stablishment.id, subcategorization.id)
                    .then(beds => {
                      let total = beds.length;
                      let enabled = beds.filter(bed => bed.state == "HABILITADA" && bed.state1 != "eliminada").length;
                      let occupied = beds.filter(bed => bed.patient_id != null  && bed.state1 != "eliminada").length;
                      let blocked = beds.filter(bed => bed.state == "BLOQUEADA"  && bed.state1 != "eliminada").length;
                      let ventilator = beds.filter(bed => bed.ventilator_used == "si" && bed.patient_id != null && bed.state1 != "eliminada").length;
                      let hasVentilator = beds.filter(bed => bed.ventilator == "si" && bed.state == "HABILITADA" && bed.state1 != "eliminada").length;
                      let covid19 = beds.filter(bed => bed.covid19 == "positivo" && bed.patient_id != null && bed.state1 != "eliminada").length;
                      let occupation = enabled == 0 ? 0 : (occupied*100/enabled).toFixed(2);
                      subcategorizationData.stablishments[stablishment.index] = {
                        total,
                        enabled,
                        occupied,
                        blocked,
                        occupation,
                        ventilator,
                        hasVentilator,
                        covid19,
                        stablishment
                      }
                      this.stablishmentDataBasic[stablishment.index].total += total;
                      this.stablishmentDataBasic[stablishment.index].enabled += enabled;
                      this.stablishmentDataBasic[stablishment.index].occupied += occupied;
                      this.stablishmentDataBasic[stablishment.index].blocked += blocked;
                      this.stablishmentDataBasic[stablishment.index].ventilator += ventilator;
                      this.stablishmentDataBasic[stablishment.index].hasVentilator += hasVentilator;
                      this.stablishmentDataBasic[stablishment.index].covid19 += covid19;
                      this.stablishmentDataBasic[stablishment.index].occupation = 
                        this.stablishmentDataBasic[stablishment.index].occupied == 0 ? 
                        0 : 
                        ((this.stablishmentDataBasic[stablishment.index].occupied*100)/this.stablishmentDataBasic[stablishment.index].enabled).toFixed(2);
                      resolveStablishment();
                    });
                })
              );
            });
            Promise.all(stablishmentPromises)
              .then(() => {
                this.dataBasicBeds.push(subcategorizationData);
                resolveSub();
              });
          })
        );
      });

      await Promise.all(subcategorizationPromises)
        .then(() => {
          // this.isLoading = false;
        });
    },
    async getMediumData() {
      let stablishments = await GetAllStablishment(this.$http);
      if (this.stablishmentId) {
        stablishments = stablishments.filter(stablishment => stablishment.id == this.stablishmentId);
      }
      this.stablishments = stablishments.map((stablishment, index) => {
        return {
          ...stablishment,
          index
        }
      });
      this.stablishmentDataMedium = this.stablishments.map(stablishment => {
        return {
          ...stablishment,
          total: 0,
          enabled: 0,
          occupied: 0,
          blocked: 0,
          occupation: 0,
          ventilator: 0,
          hasVentilator: 0,
          covid19: 0
        }
      });
      const subcategorizations = await GetSubcategorizationByClassification(
        this.$http,
        "media"
      );
      let subcategorizationPromises = [];
      subcategorizations.forEach(subcategorization => {
        subcategorizationPromises.push(
          new Promise((resolveSub) => {
            let subcategorizationData = {
              subcategorization,
              stablishments: [],
            };
            let stablishmentPromises = [];
            this.stablishments.forEach(stablishment => {
              stablishmentPromises.push(
                new Promise((resolveStablishment) => {
                  BedFindByStablishmentSubCatId(this.$http, stablishment.id, subcategorization.id)
                    .then(beds => {
                      let total = beds.length;
                      let enabled = beds.filter(bed => bed.state == "HABILITADA" && bed.state1 != "eliminada").length;
                      let occupied = beds.filter(bed => bed.patient_id != null && bed.state1 != "eliminada").length;
                      let blocked = beds.filter(bed => bed.state == "BLOQUEADA" && bed.state1 != "eliminada").length;
                      let ventilator = beds.filter(bed => bed.ventilator_used == "si" && bed.patient_id != null && bed.state1 != "eliminada").length;
                      let hasVentilator = beds.filter(bed => bed.ventilator == "si" && bed.state == "HABILITADA" && bed.state1 != "eliminada").length;
                      let covid19 = beds.filter(bed => bed.covid19 == "positivo" && bed.patient_id != null && bed.state1 != "eliminada").length;
                      let occupation = enabled == 0 ? 0 : (occupied*100/enabled).toFixed(2);
                      subcategorizationData.stablishments[stablishment.index] = {
                        total,
                        enabled,
                        occupied,
                        blocked,
                        occupation,
                        ventilator,
                        hasVentilator,
                        covid19,
                        stablishment
                      }
                      this.stablishmentDataMedium[stablishment.index].total += total;
                      this.stablishmentDataMedium[stablishment.index].enabled += enabled;
                      this.stablishmentDataMedium[stablishment.index].occupied += occupied;
                      this.stablishmentDataMedium[stablishment.index].blocked += blocked;
                      this.stablishmentDataMedium[stablishment.index].ventilator += ventilator;
                      this.stablishmentDataMedium[stablishment.index].hasVentilator += hasVentilator;
                      this.stablishmentDataMedium[stablishment.index].covid19 += covid19;
                      this.stablishmentDataMedium[stablishment.index].occupation = 
                        this.stablishmentDataMedium[stablishment.index].occupied == 0 ? 
                        0 : 
                        ((this.stablishmentDataMedium[stablishment.index].occupied*100)/this.stablishmentDataMedium[stablishment.index].enabled).toFixed(2);
                      resolveStablishment();
                    });
                })
              );
            });
            Promise.all(stablishmentPromises)
              .then(() => {
                this.dataMediumBeds.push(subcategorizationData);
                resolveSub();
              });
          })
        );
      });

      await Promise.all(subcategorizationPromises)
        .then(() => {
          // this.isLoading = false;
        });
    },
    async getCriticalData() {
      let stablishments = await GetAllStablishment(this.$http);
      if (this.stablishmentId) {
        stablishments = stablishments.filter(stablishment => stablishment.id == this.stablishmentId);
      }
      this.stablishments = stablishments.map((stablishment, index) => {
        return {
          ...stablishment,
          index
        }
      });
      this.stablishmentDataCritical = this.stablishments.map(stablishment => {
        return {
          ...stablishment,
          total: 0,
          enabled: 0,
          occupied: 0,
          blocked: 0,
          occupation: 0,
          ventilator: 0,
          hasVentilator: 0,
          covid19: 0
        }
      });
      const subcategorizations = await GetSubcategorizationByClassification(
        this.$http,
        "critica"
      );
      let subcategorizationPromises = [];
      subcategorizations.forEach(subcategorization => {
        subcategorizationPromises.push(
          new Promise((resolveSub) => {
            let subcategorizationData = {
              subcategorization,
              stablishments: [],
            };
            let stablishmentPromises = [];
            this.stablishments.forEach(stablishment => {
              stablishmentPromises.push(
                new Promise((resolveStablishment) => {
                  BedFindByStablishmentSubCatId(this.$http, stablishment.id, subcategorization.id)
                    .then(beds => {
                      let total = beds.length;
                      let enabled = beds.filter(bed => bed.state == "HABILITADA" && bed.state1 != "eliminada").length;
                      let occupied = beds.filter(bed => bed.patient_id != null && bed.state1 != "eliminada").length;
                      let blocked = beds.filter(bed => bed.state == "BLOQUEADA" && bed.state1 != "eliminada").length;
                      let ventilator = beds.filter(bed => bed.ventilator_used == "si" && bed.patient_id != null && bed.state1 != "eliminada").length;
                      let hasVentilator = beds.filter(bed => bed.ventilator == "si" && bed.state == "HABILITADA" && bed.state1 != "eliminada").length;
                      let covid19 = beds.filter(bed => bed.covid19 == "positivo" && bed.patient_id != null && bed.state1 != "eliminada").length;
                      let occupation = enabled == 0 ? 0 : (occupied*100/enabled).toFixed(2);
                      //START SUMMARY
                      if (subcategorization.id == 1) {//UCI ADULTO
                        this.summaryTable.forEach((row, index) => {
                          if (row.ids.includes(stablishment.id)) {
                            this.summaryTable[index].uciEnabled += enabled;
                            this.summaryTable[index].uciOccupied += occupied;
                            this.summaryTable[index].uciAvailable += (enabled - occupied);
                            this.summaryTable[index].occupiedVentilators += ventilator;
                            this.summaryTable[index].availableVentilators += (hasVentilator - ventilator);
                          }
                          if (row.ids.includes("total")) {
                            this.summaryTable[index].uciEnabled += enabled;
                            this.summaryTable[index].uciOccupied += occupied;
                            this.summaryTable[index].uciAvailable += (enabled - occupied);
                            this.summaryTable[index].occupiedVentilators += ventilator;
                            this.summaryTable[index].availableVentilators += (hasVentilator - ventilator);
                          }
                        });
                      }
                      if (subcategorization.id == 4) {//UTI ADULTO
                        this.summaryTable.forEach((row, index) => {
                          if (row.ids.includes(stablishment.id)) {
                            this.summaryTable[index].utiEnabled += enabled;
                            this.summaryTable[index].utiOccupied += occupied;
                            this.summaryTable[index].utiAvailable += (enabled - occupied);
                            this.summaryTable[index].occupiedVentilators += ventilator;
                            this.summaryTable[index].availableVentilators += (hasVentilator - ventilator);
                          }
                          if (row.ids.includes("total")) {
                            this.summaryTable[index].utiEnabled += enabled;
                            this.summaryTable[index].utiOccupied += occupied;
                            this.summaryTable[index].utiAvailable += (enabled - occupied);
                            this.summaryTable[index].occupiedVentilators += ventilator;
                            this.summaryTable[index].availableVentilators += (hasVentilator - ventilator);
                          }
                        });
                      }
                      //END SUMMARY
                      subcategorizationData.stablishments[stablishment.index] = {
                        total,
                        enabled,
                        occupied,
                        blocked,
                        occupation,
                        ventilator,
                        hasVentilator,
                        covid19,
                        stablishment
                      }
                      this.stablishmentDataCritical[stablishment.index].total += total;
                      this.stablishmentDataCritical[stablishment.index].enabled += enabled;
                      this.stablishmentDataCritical[stablishment.index].occupied += occupied;
                      this.stablishmentDataCritical[stablishment.index].blocked += blocked;
                      this.stablishmentDataCritical[stablishment.index].ventilator += ventilator;
                      this.stablishmentDataCritical[stablishment.index].hasVentilator += hasVentilator;
                      this.stablishmentDataCritical[stablishment.index].covid19 += covid19;
                      this.stablishmentDataCritical[stablishment.index].occupation = 
                        this.stablishmentDataCritical[stablishment.index].occupied == 0 ? 
                        0 : 
                        ((this.stablishmentDataCritical[stablishment.index].occupied*100)/this.stablishmentDataCritical[stablishment.index].enabled).toFixed(2);
                      resolveStablishment();
                    });
                })
              );
            });
            Promise.all(stablishmentPromises)
              .then(() => {
                this.dataCriticalBeds.push(subcategorizationData);
                resolveSub();
              });
          })
        );
      });

      await Promise.all(subcategorizationPromises)
        .then(() => {
          // this.isLoading = false;
        });
    }
  },
};
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .col-header {
    background-color: #3c3ebc;
    color: #f0f0f0;
  }
  .col-subheader {
    background-color: #dcdcff !important;
  }
  .col-percentage {
    background-color: #c3c3ff !important;
  }
  td:first-child, th:first-child {
    position:sticky;
    left:0;
    z-index:1;
    background-color: #fafafa;
    /* box-shadow: 5px 3px 14px 0px rgba(0,0,0,0.75); */
  }
  /* td:last-child, th:last-child {
    position:sticky;
    right:0;
    z-index:1;
    background-color:blue;
  } */
  thead tr th {
    position:sticky;
    top:0;
  }
  th {
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
  }
</style>